export class HourlyTempModel{
  temperature_850hPa: number;
  temperature_700hPa: number;
  hour: string;
  hourlySurfaceT: number;


  constructor(_temperature_850hPa: number, _temperature_700hPa: number, _hour: string,
    _hourlySurfaceT: number) {
    this.temperature_850hPa = _temperature_850hPa;
    this.temperature_700hPa = _temperature_700hPa;
    this.hour = _hour;
    this.hourlySurfaceT= _hourlySurfaceT;
  }
}
